import React, { useContext } from "react";
import { Route, Navigate, Outlet } from "react-router-dom";
import { AuthContext } from "./firebase/Authentication";
const LoginRoute = ({ component: RouteComponent, ...rest }) => {
    const { currentUser } = useContext(AuthContext);
    return !currentUser ? <Outlet /> : <Navigate to="/" />;
};

export default LoginRoute;
